import {useEffect} from "react";
import {Initialize} from "../hooks/initialize";

export default function AuthProvider({children}) {
    useEffect(() => {
        Initialize()
    }, []);



    return (
        <>
            {children}
        </>
    )
}
